export default __webpack_public_path__ + "static/media/WBTCwh.d8219479.svg";